(ns livefeed.topic-slideup
  (:require [livefeed.slideup :as slideup]
            [clojure.string :as str]
            [livefeed.util :refer [local-storage-get local-storage-set]]
            [livefeed.i18n :refer [translate]]
            ["@yleisradio/yds-components-react" :refer [Button]]))

;; Local storage - if the user has seen the topic slideup,
;; save chat-id to a list in local storage and don't show it again
(def ^:private local-storage-key "chat-description-seen")
(def ^:private max-seen-ids 5)

(defn not-seen? [chat-id]
  (let [seen-list (local-storage-get local-storage-key [])]
    (not (some #{chat-id} seen-list))))

(defn set-seen [chat-id]
  (let [seen-list (js->clj (local-storage-get local-storage-key []))
        updated-list (if (some #{chat-id} seen-list)
                       seen-list
                       (let [new-list (conj seen-list chat-id)]
                         (if (> (count new-list) max-seen-ids)
                           (vec (drop 1 new-list))
                           new-list)))]
    (local-storage-set local-storage-key (clj->js updated-list))))
;; /Local storage

;; URLs must end in an alphanumeric ASCII character or a slash because they may
;; be followed by punctuation, e.g. "Check out https://yle.fi!"
(def url-regex #"https?://[^\s]+[a-zA-Z0-9/]")

(defn- parse-text-with-links [text]
  (let [matches (re-seq url-regex text)
        parts (str/split text url-regex)]
    (loop [result []
           [part & remaining-parts] parts
           [url & remaining-urls] matches]
      (if part
        (recur
         (cond-> (conj result part)
           url (conj [:a.yle-livefeed__topic-slideup__description__link
                      {:href url
                       :target "_blank"
                       :rel "noopener noreferrer"} url]))
         remaining-parts
         remaining-urls)
        result))))

(defn- render-description [text]
  (when text
    (into [:span]
          (parse-text-with-links text))))

(defn component [open? on-close title description]
  [slideup/component
   open?
   on-close
   "cw-to-chat"
   [:div.yle-livefeed__topic-slideup
    [:p.yle-livefeed__topic-slideup__title title]
    [:p.yle-livefeed__topic-slideup__description (render-description description)]
    [:> Button {:id "cw-to-chat"
                :onClick on-close
                :fullWidth true
                :size "sm"}
     (translate :to-chat)]]])
